// extracted by mini-css-extract-plugin
export var footer = "_na-5";
export var fulfillmentInput = "_na-0";
export var shipDateInput = "_na-1";
export var shipmentModal = "_na-2";
export var shipmentModalContent = "_na-3";
export var tableContainer = "_na-4";